let window = <any>global.window || {};
declare global {
  interface Window {
    isFakeProduction: boolean;
    setIsFakeProduction: (boolean) => void;
  }
}

window.isFakeProduction = false;

window.setIsFakeProduction = (flag: boolean) => {
  window.isFakeProduction = flag;
};

export const isFakeProduction = () => window?.isFakeProduction;

console.log("REACT_APP_ENVIRONMENT", process.env.REACT_APP_ENVIRONMENT);
export const isProduction = () =>
  process.env.REACT_APP_ENVIRONMENT === "production";

export const isCalculator = () =>
  window?.location.hostname.includes("covid19risk.");

export const isLocal = () => window?.location.hostname.includes("localhost");
